import type { ReactNode } from 'react';

import { RoleRequired } from '@/components/common/RoleRequired';
import { useBridgeAperto } from '@/components/bridge/useBridgeAperto';

/**
 * Il cancello delle rotte di K9a (condizione 4 di tma-orcr): «beta OPPURE ospite».
 *
 * Perche': «la prima mano senza account» e' approvata da Luca (L-3002), e un ospite che sbatte su «ruolo beta richiesto» la contraddice.
 * `<RoleGate role="beta">` guarda i ruoli Logto e l'ospite non ne ha (`RoleGate.tsx`). Il cancello e' UN componente con un nome, che usa
 * `useBridgeAperto()` (= `useHasLogtoRole('beta')` OR `useOspite()`, cosi' come sono): lo stesso predicato della tessera della Hub.
 *
 * ⚠️ Vale SOLO per le rotte di K9a (ingresso, prima mano, lezioni, «Perche'?»). La smazzata dei robot di R0 e tutto cio' che verra' dopo
 * (pratica, tavolo) restano dietro `<RoleGate role="beta">`. Un loggato SENZA beta vede `<RoleRequired />`, come prima.
 */
export function CancelloBridge({ children }: { children: ReactNode }) {
  if (useBridgeAperto()) return <>{children}</>;
  return <RoleRequired role="beta" />;
}
